import { render, staticRenderFns } from "./VueXLSXDownloadComponent.vue?vue&type=template&id=3438ab82"
import script from "./VueXLSXDownloadComponent.vue?vue&type=script&lang=js"
export * from "./VueXLSXDownloadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports